module.exports = __webpack_public_path__ + "static/media/pestec.3884bfeb.png";